var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 0C3.25195 0 0.199951 3.04802 0.199951 6.8C0.199951 8.34001 1.29194 11.008 3.44395 14.724C4.28394 16.18 5.10793 17.48 5.65195 18.316C6.74795 20 6.74795 20 6.99995 20C7.25596 20 7.25596 20 8.35195 18.316C8.89595 17.48 9.71995 16.18 10.5599 14.724C12.7119 11.008 13.8 8.34001 13.8 6.8C13.8 3.04802 10.752 0 6.99995 0ZM6.99995 10.4C5.01594 10.4 3.39995 8.78401 3.39995 6.8C3.39995 4.81201 5.01594 3.2 6.99995 3.2C8.98794 3.2 10.6 4.81201 10.6 6.8C10.6 8.78401 8.98794 10.4 6.99995 10.4Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location_marker.e5bfa3ef993d7ae2b8367cd8952e1d97.svg";
export { ForwardRef as ReactComponent };